import { useState } from 'react';
import { Grid } from '@mui/material';
import { startOfDay } from 'date-fns';

import TimeWarningLogFilters from './TimeWarningLogFilters';
import TimeWarningLogTable from './TimeWarningLogTable';

import { Filter } from './types';
import { useTimeWarningLog } from './api/useTimeWarningLog';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';
import { zonedTimeToUtc } from 'date-fns-tz';

const TimeWarningLogPage = () => {
  const { timezone } = useUserDateTime();
  const [filter, setFilter] = useState<Filter>({
    fromDate: startOfDay(new Date()),
    toDate: new Date(),
    analyzerId: -1,
  });

  const fromDateString = zonedTimeToUtc(
    filter.fromDate,
    timezone
  ).toISOString();
  const toDateString = zonedTimeToUtc(filter.toDate, timezone).toISOString();

  const { data: timeWarningLog } = useTimeWarningLog({
    fromDate: fromDateString,
    toDate: toDateString,
    analyzerId: filter.analyzerId,
  });

  const handleFilterChanged = (newFilter: Filter) => {
    setFilter(newFilter);
  };

  return (
    <Grid container>
      <Grid item xs={12} style={{ paddingBottom: '1.5rem' }}>
        <TimeWarningLogFilters
          filter={filter}
          handleFilterChanged={handleFilterChanged}
        />
      </Grid>
      <Grid item xs={12}>
        <TimeWarningLogTable timeWarningLog={timeWarningLog} />
      </Grid>
    </Grid>
  );
};

export default TimeWarningLogPage;
